export const TEST_ID = 'panelSection';
